import { Suspense } from "react";
import MainLayout from "layout/MainLayout";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { mainRoutes } from "./featureRoutes";
import AuthLayout from "layout/AuthLayout";
import { authRoutes } from "features/auth/routes/authRoutes";
import ProtectedMainRoute from "./guards/ProtectedMainRoute";
import ProtectedAuthRoute from "./guards/ProtectedAuthRoute";
import HomeRedirect from "./guards/HomeRedirect";
import NotFoundPage from "components/NotFound";
import { architectureRoutes } from "features/architecture/routes/routes";
import ArchitectureLayout from "features/architecture/layouts/ArchitectureLayout";
import { CitySceneCard } from "components/CityScene/CitySceneCard";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ padding: 24 }}>Loading...</div>}>
        <Routes>
          <Route element={<MainLayout />}>
            {mainRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedMainRoute route={route}>
                    <route.component />
                  </ProtectedMainRoute>
                }
              />
            ))}
            <Route path="home">
              <Route
                index
                element={
                  <ProtectedMainRoute
                    route={{ path: "/home", component: CitySceneCard }}
                  >
                    <CitySceneCard />
                  </ProtectedMainRoute>
                }
              />
              <Route path="architecture" element={<ArchitectureLayout />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                {architectureRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <ProtectedMainRoute route={route}>
                        <route.component />
                      </ProtectedMainRoute>
                    }
                  />
                ))}
              </Route>
            </Route>
          </Route>

          <Route element={<AuthLayout />}>
            {authRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedAuthRoute route={route}>
                    <route.component />
                  </ProtectedAuthRoute>
                }
              />
            ))}
          </Route>

          <Route path="/" element={<HomeRedirect />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
